<script setup lang="ts">
import * as CheckoutSDK from '@bambora/checkout-sdk-web'
import { cn } from 'pejer/src/lib/utils'
import { onUnmounted, ref, watch } from 'vue'

const props = defineProps<{
  sessionToken: string
  paymentReferenceID: string
}>()

const emits = defineEmits<{
  (e: 'onPaidSuccess', value: null): void
}>()

const containerRef = ref<HTMLElement | null>(null)
const checkoutInstance = ref<CheckoutSDK.InlineCheckout | null>(null)

watch(
  () => containerRef.value,
  (container) => {
    if (!container) return

    const checkout = new CheckoutSDK.InlineCheckout(props.sessionToken, {
      container: containerRef.value,
      eventHandlerMap: {
        authorize: [
          (event) => {
            console.log('Bambora Authorize event:', event)
            emits('onPaidSuccess', null)
          },
        ],
      },
    })
    checkoutInstance.value = checkout
  },
  { immediate: true }
)

onUnmounted(() => {
  if (checkoutInstance.value) checkoutInstance.value.destroy()
})
</script>
<template>
  <div ref="containerRef" :class="cn('h-full min-h-[600px] transition-all duration-300')"></div>
</template>
